import { render } from "./EventsList.vue?vue&type=template&id=79632dff&scoped=true"
import script from "./EventsList.vue?vue&type=script&lang=js"
export * from "./EventsList.vue?vue&type=script&lang=js"

import "./EventsList.vue?vue&type=style&index=0&id=79632dff&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-79632dff"

export default script